// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function TextCarousel() {

    var self = this,
      $el = null,

      options = {
        example: null,
      };


    /**
     * Init Images Carousel
     */
    function initTextCarousel() {
      var textCarousel = new Swiper('.js-text-carousel', {
        loop: true,
        slidesPerView: 1,
        allowTouchMove: false,
        speed: 1000,
        centeredSlides: true,
        navigation: {
          nextEl: '.js-text-carousel-button-next',
          prevEl: '.js-text-carousel-button-prev',
        },
        pagination: {
          el: '.js-text-carousel-button-pagination',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          // when window width is <= 640px
          991: {
            allowTouchMove: true
          }
        }
      });
    }


    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'lg' || window.bp.getValue() === 'xl') {
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }


      // Caching
      $el = options.$el;

      // Init Text Carousel
      if($('.js-text-carousel .swiper-slide').length > 1) {
        initTextCarousel();
      } else {
        $('.js-text-carousel').addClass('no-carousel');
      }

      // *************
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Components.TextCarousel = TextCarousel;

}(jQuery));